import checkpointIsland from "assets/illustrations/checkpointIsland.svg"
import unlockedSunrise from "assets/illustrations/unlockedSunrise.svg"
import { useHasValueChanged, useOnEscape } from "hooks"
import { useDisableDocumentScroll } from "hooks/src/useDisableDocumentScroll"
import { Button, Modal } from "materia"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { backgroundImageStyle } from "ui-tools"
import { FiestaImage } from "utility-components"
import { Sparkles } from "../../Sparkles"

import s from "./CheckpointUnlockedModal.module.scss"

export const CheckpointUnlockedModal = ({
  isUnlocked,
  initialShowModal,
  onModalClose,
}: {
  isUnlocked: boolean
  initialShowModal?: boolean
  onModalClose: () => void
}) => {
  const [isOpen, setIsOpen] = useState(true)

  const isUnlockedChanged = useHasValueChanged(isUnlocked)
  const showModal =
    initialShowModal ?? (isOpen && isUnlocked && isUnlockedChanged)

  if (!showModal) return

  const onClose = () => {
    setIsOpen(false)
    onModalClose()
  }

  return <Content onClose={onClose} />
}

const Content = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation()

  useOnEscape(onClose)
  useDisableDocumentScroll()

  return (
    <Modal
      onClose={onClose}
      overflowAuto={false}
      ariaLabel="Checkpoint unlocked"
    >
      <div className={s.checkpointUnlockedModal}>
        <Sparkles />

        <div
          className={s.checkpointUnlockedModal__cover}
          style={backgroundImageStyle(unlockedSunrise)}
        >
          <FiestaImage
            sizes="90px"
            className={s.checkpointUnlockedModal__coverThumbnail}
            src={checkpointIsland}
            alt=""
          />
        </div>
        <div className={s.checkpointUnlockedModal__content}>
          <h3 className={s.checkpointUnlockedModal__contentTitle}>
            {t("journey.CHECKPOINT_UNLOCKED_TITLE")}
          </h3>
          <p className={s.checkpointUnlockedModal__contentDescription}>
            {t("journey.CHECKPOINT_UNLOCKED_DESCRIPTION")}
          </p>
          <Button onClick={onClose} borderRadius={"32"}>
            {t("journey.CHECKPOINT_UNLOCKED_CONTINUE")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
